// import React, { useState, useEffect } from "react";
// import CreatableSelect from "react-select/creatable";
// import classNames from "classnames";
// import logger from "../../../utils/logger";

// // Ahora el componente espera value/onChange/onBlur desde Controller
// export const GenericCreatableSelect2 = ({
//   value = [],
//   onChange,
//   onBlur,
//   name,
//   multi = true,
//   placeholder = "",
//   options = [],
//   selectClass = "",
//   showError = false,
// }) => {
//   const [inputValue, setInputValue] = useState("");

//   // ⚡ Esto solo maneja internamente la opción que escribimos (tag manual)
//   const handleInputChange = (val) => {
//     if (val.endsWith(";")) {
//       const clean = val.slice(0, -1).trim();
//       if (clean) handleCreateOption(clean);
//       return "";
//     }
//     setInputValue(val);
//     return val;
//   };

//   const normalize = (str) => str.trim().toLowerCase();
//   const existsInSelected = (label) =>
//     value.some((item) => normalize(item.label || item) === normalize(label));

//   const handleCreateOption = (label) => {
//     if (!label || existsInSelected(label)) return;

//     const newOption = { label, value: label };
//     const updated = [...(value || []), newOption];

//     onChange(updated.map((o) => o)); // avisamos a RHF
//     setInputValue("");
//   };

//   const handleChange = (selected) => {
//     const normalized = Array.isArray(selected) ? selected : [];
//     onChange(normalized);
//   };

//   return (
//     <div className="w-100">
//       <CreatableSelect
//         isMulti={multi}
//         name={name}
//         value={value}
//         options={options}
//         placeholder={placeholder}
//         onChange={handleChange}
//         onInputChange={handleInputChange}
//         onCreateOption={handleCreateOption}
//         onBlur={onBlur}
//         inputValue={inputValue}
//         className={classNames(selectClass)}
//         formatCreateLabel={(inputValue) =>
//           value.length >= 10
//             ? "Máximo 10 profesores permitidos"
//             : `¿Desea agregar "${inputValue}"?`
//         }

//         styles={{
//           control: (base) => ({
//             ...base,
//             borderRadius: "15px",
//             borderColor: showError ? "#F06292" : base.borderColor,
//             backgroundColor: showError ? "#fdefef" : base.backgroundColor,
//             boxShadow: "none",
//           }),
//           multiValue: (base) => ({
//             ...base,
//             backgroundColor: "#e3e3e3",
//             borderRadius: "7px",
//             paddingInline: "4px",
//           }),
//           multiValueLabel: (base) => ({
//             ...base,
//             color: "#757575",
//             fontWeight: "500",
//           }),
//           multiValueRemove: (base) => ({
//             ...base,
//             color: "#757575",
//             ":hover": {
//               backgroundColor: "#3a3838ff",
//               color: "#fff",
//             },
//           }),
//         }}
//       />

//       {showError && (
//         <span className="invalid-feedback d-flex field-validation-error">
//           <span className="error-message">Campo requerido</span>
//         </span>
//       )}
//     </div>
//   );
// };


import React, { useState } from "react";
import CreatableSelect from "react-select/creatable";
import classNames from "classnames";

export const GenericCreatableSelect2 = ({
  value = [],
  onChange,
  onBlur,
  name,
  multi = true,
  placeholder = "",
  options = [],
  selectClass = "",
  showError = false,
}) => {
  const [inputValue, setInputValue] = useState("");
  const MIN_CHARS = 3;

  const normalize = (str) => str.trim().toLowerCase();

  const existsInSelected = (label) =>
    value.some((item) =>
      normalize(item.label || item) === normalize(label)
    );

  const handleCreateOption = (label) => {
    if (!label || existsInSelected(label) || value.length >= 10) return;

    const newOption = { label, value: label };
    onChange([...(value || []), newOption]);
    setInputValue("");
  };

  const handleInputChange = (val) => {
    if (val.endsWith(";")) {
      const clean = val.slice(0, -1).trim();
      if (clean) handleCreateOption(clean);
      return "";
    }
    setInputValue(val);
    return val;
  };

  const handleChange = (selected) => {
    onChange(Array.isArray(selected) ? selected : []);
  };

  /* 🎯 CLAVE */
  const filteredOptions =
    inputValue.length >= MIN_CHARS
      ? options.filter(o =>
          o.label.toLowerCase().includes(inputValue.toLowerCase())
        )
      : [];

  return (
    <div className="w-100">
      <CreatableSelect
        isMulti={multi}
        name={name}
        value={value}
        options={filteredOptions}
        placeholder={placeholder}
        onChange={handleChange}
        onInputChange={handleInputChange}
        onCreateOption={handleCreateOption}
        onBlur={onBlur}
        inputValue={inputValue}
        className={classNames(selectClass)}
        noOptionsMessage={() =>
          inputValue.length < MIN_CHARS
            ? "Escribe al menos 3 caracteres..."
            : "Sin coincidencias"
        }
        formatCreateLabel={(inputValue) =>
          value.length >= 10
            ? "Máximo 10 profesores permitidos"
            : `¿Desea agregar "${inputValue}"?`
        }
        styles={{
          control: (base) => ({
            ...base,
            borderRadius: "15px",
            borderColor: showError ? "#F06292" : base.borderColor,
            backgroundColor: showError ? "#fdefef" : base.backgroundColor,
            boxShadow: "none",
          }),
          multiValue: (base) => ({
            ...base,
            backgroundColor: "#e3e3e3",
            borderRadius: "7px",
            paddingInline: "4px",
          }),
          multiValueLabel: (base) => ({
            ...base,
            color: "#757575",
            fontWeight: "500",
          }),
          multiValueRemove: (base) => ({
            ...base,
            color: "#757575",
            ":hover": {
              backgroundColor: "#3a3838ff",
              color: "#fff",
            },
          }),
        }}
      />

      {showError && (
        <span className="invalid-feedback d-flex field-validation-error">
          <span className="error-message">Campo requerido</span>
        </span>
      )}
    </div>
  );
};
